import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { cities } from "@/lib/data/cities";

export default function CoverageGrid() {
  return (
    <section
      data-testid="coverage-grid"
      className="relative bg-[#050505] border-t border-[#1e1e1e] py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 grid grid-cols-12 gap-6 mb-16">
        <div className="col-span-12 md:col-span-4">
          <p className="font-editorial italic text-[#FF3B30] text-sm">
            04 — Coverage
          </p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <h2 className="font-display font-black uppercase tracking-tightest leading-[0.9] text-white text-4xl md:text-6xl lg:text-7xl">
            Every community
            <br />
            <span className="font-editorial italic font-normal text-[#a0a0a0]">
              from the 49th
            </span>{" "}
            to the tundra.
          </h2>
        </div>
      </div>

      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-6 gap-y-3">
          {cities.map((c, i) => (
            <motion.li
              key={c.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{
                duration: 0.6,
                delay: (i % 20) * 0.02,
                ease: [0.16, 1, 0.3, 1],
              }}
            >
              <Link
                to={`/cities/${c.slug}`}
                data-testid={`coverage-city-${c.slug}`}
                className="group flex items-baseline justify-between border-b border-[#1e1e1e] py-3 hover:border-[#FF3B30] transition-colors duration-500"
              >
                <span className="font-display uppercase tracking-tight text-white text-base md:text-lg group-hover:translate-x-1 transition-transform">
                  {c.name}
                </span>
                <span className="font-editorial italic text-[#6a6a6a] text-xs">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </Link>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
